import { render, staticRenderFns } from "./bills.vue?vue&type=template&id=33952e94"
import script from "./bills.vue?vue&type=script&lang=js"
export * from "./bills.vue?vue&type=script&lang=js"
import style0 from "./bills.vue?vue&type=style&index=0&id=33952e94&prod&rel=stylesheet%2Fscss&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports